import { render, staticRenderFns } from "./ContMyDatasourcesGdsComponent.vue?vue&type=template&id=0f317b47&scoped=true&lang=pug"
import script from "./ContMyDatasourcesGdsComponent.vue?vue&type=script&lang=js"
export * from "./ContMyDatasourcesGdsComponent.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0f317b47",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/jquispe/itcm-inca-platform-app/frontend/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('0f317b47')) {
      api.createRecord('0f317b47', component.options)
    } else {
      api.reload('0f317b47', component.options)
    }
    module.hot.accept("./ContMyDatasourcesGdsComponent.vue?vue&type=template&id=0f317b47&scoped=true&lang=pug", function () {
      api.rerender('0f317b47', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/apps/data-platform/modules/my_objects/components/ContMyDatasourcesGdsComponent.vue"
export default component.exports